import { getBootstrapData } from "@swa-ui/bootstrap";

/**
 * getAirlineByIATA
 *
 * Parameter Example: 'WN'
 * Return value: Airline info for given IATADesignator. 'undefined' will be return if IATADesignator is invalid.
 */

export const getAirlineByIATA = (IATADesignator) =>
  getBootstrapData("air/airline-info")?.find(
    (airlineInfo) => airlineInfo.IATADesignator === IATADesignator
  );

/**
 * getAirlineNameByIATA outputs the display name from a given IATADesignator.
 *
 * Parameter example: 'WN'
 * Return value: airline's name
 *
 */

export const getAirlineNameByIATA = (IATADesignator) =>
  getAirlineByIATA(IATADesignator)?.name ?? "";
